module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2t9ZK"))).then(() => parcelRequire('hEqeo'));